// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + "14c1c3c02e5b2efe68bd" + "." + chunkId + ".css";
};